export const DT_VIEW_LIST = 'LIST'
export const DT_VIEW_BOARD = 'BOARD'
export const DT_VIEW_CARD = 'CARD'
export const DT_VIEW_CALENDAR = 'CALENDAR'
export const DT_VIEW_GRID = 'GRID'

export const DT_VIEW_REPORT = 'REPORT'
export const DT_VIEW_CONVERSATION = 'CONVERSATION'

export const docViewTypes = Object.freeze({
    list: {
        key: DT_VIEW_LIST,
        label: 'List',
        icon: 'fal fa-bars',
        isDocView: true,
        isConfigurable: true,
        isSupported: true
    },
    board: {
        key: DT_VIEW_BOARD,
        label: 'Board',
        icon: 'fal fa-columns',
        isDocView: true,
        isConfigurable: true,
        isSupported: true
    },
    grid: {
        key: DT_VIEW_GRID,
        label: 'Table',
        icon: 'fal fa-table',
        isDocView: true,
        isConfigurable: true,
        isSupported: true
    },
    card: {
        key: DT_VIEW_CARD,
        label: 'Card',
        icon: 'far fa-square',
        isDocView: true,
        isConfigurable: true
    },
    calendar: {
        key: DT_VIEW_CALENDAR,
        label: 'Calendar',
        icon: 'far fa-calendar',
        isDocView: true,
        isConfigurable: true
    },
    // PAGE VIEWS
    report: {
        key: DT_VIEW_REPORT,
        label: 'Report',
        icon: 'far fa-chart-line',
        isPageView: true,
        isConfigurable: true
    },
    conversation: {
        key: DT_VIEW_CONVERSATION,
        label: 'Conversation',
        icon: 'far fa-comment',
        isPageView: true,
        isConfigurable: true
    }
})

export const docViewTypesList = Object.freeze(Object.values(docViewTypes))

export const getViewTypeModelByKey = key => docViewTypesList.find(v => v.key === key) || docViewTypes.list

export const checkIsSupportedDocTypeView = key => {
    const view = docViewTypesList.find(v => v.key === key)
    return view && view.isSupported
}
